import * as next from 'next'

import * as cold from '@owl-nest/cold-data'
import { type BrandListProps } from '@bob/brand'
import * as hooks from '@bob/hooks'
import * as core from '@bob/services'

export { BrandList as default } from '@bob/brand'

export async function getStaticProps({
  locale = cold.defaultLocale.code,
}: next.GetStaticPropsContext<Record<never, never>>): Promise<next.GetStaticPropsResult<BrandListProps>> {
  if (locale !== 'fr') {
    return {
      notFound: true,
    }
  }

  const vendors = await core.brand.build.getAllMediumCollection(locale)
  const brands = vendors.filter((vendor) => !vendor.isVendorOnly)

  const environmentalPillar = cold.taxonomies[cold.types['environmental-pillar']]
  const socialPillar = cold.taxonomies[cold.types['social-pillar']]

  const brandIndex = hooks.useSearchEngine.index(brands, {
    identifier: (brand) => brand.slug,
    indexes: {
      categories: {
        title: 'Catégories',
        indexer: (brand) => {
          return brand.brandCategories.map((category) => ({
            hash: category.slug,
            title: category.name,
          }))
        },
      },
      environmentalPillar: {
        title: environmentalPillar.name,
        indexer: (brand) =>
          brand.pillars.environmental.map((tag) => ({
            hash: tag.slug,
            title: tag.name,
          })),
      },
      socialPillar: {
        title: socialPillar.name,
        indexer: (brand) =>
          brand.pillars.social.map((tag) => ({
            hash: tag.slug,
            title: tag.name,
          })),
      },
      bobChart: {
        title: 'Charte Bien ou Bien',
        indexer: (brand) => (brand.signatory ? [{ hash: 'signatory', title: 'Marques signataires' }] : []),
      },
    },
  })

  return {
    props: {
      brands,
      index: brandIndex,
    },
    revalidate: 10,
  }
}
